var timerId, listType;
var totalHaveVSChecklist = 0;

document.addEventListener("DOMContentLoaded", function () {
    var loadingWrap = document.querySelector('.loading-data');
    var checklistDataWrap = document.querySelector('#checklistdata');
    var checklistDataJSON;
    var levelsDataWrap = document.querySelector('#checklistlevels');
    var levelsDataJSON = JSON.parse(levelsDataWrap.innerText);
    var headerTitles = document.querySelectorAll('.checklist-table-header > div');
    var editionDropdowns = document.querySelectorAll('.edition-dropdown');
    var tableWrap = document.querySelector('.vinegar-checklist-table-wrapper');
    var sortSelect = document.querySelector('.sort-select');
    var sortSelected = document.querySelector('.tablesaw-btn-select > span');
    var currentSorting = document.querySelector('.sort-asc');
    var countVS = document.querySelector('#cwc-vs-count');
    var levelVS = document.querySelector('#cwc-vs-level');
    var makepublic = document.querySelector('.public-list');
    var tryagain = document.querySelector('#saving a');
    var sharelink = document.querySelector('.share-link');
    var sharelinkButton = document.querySelector('.share-list');
    var listNames = document.querySelectorAll('.list-name');
    var searchInput = document.querySelector('#search-title');
    var clearinput = document.querySelector('.clearinput');

    var colHeaders = [
        'have',
        'need',
        'cat',
        'released',
        'title',
        'type',
        'format',
        'series',
        'edition',
        'status',
        'notes',
    ];

    var publicType, allRows, orderBy, nodeArray, functionRef, sortValue, sortClass, newHeaderSort, dataSelector, newArr, searchId, selectVariant, copyInProcess;

    // Hide products variables
    var allHiddenCheck = tableWrap.querySelectorAll('.hide-product-row');
    var unhideBtn = tableWrap.querySelector('.unhide-all');
    var hiddenCtnWp = tableWrap.querySelector('#hiddencount');
    var hiddenCount = 0;
    var allHidden;

    // Have product variables
    var allHaveCheck = tableWrap.querySelectorAll('.row-have input');

    // Need product variables
    var allNeedCheck = tableWrap.querySelectorAll('.row-need input');

    // Set list type
    listType = tableWrap.dataset.list == 'vinegar' ? 'vinegar' : 'partner';
    console.log(listType);

    function postData(url, data) {
        return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: data
        });
    }

    if (typeof tryagain != 'undefined' && tryagain != null) {
        tryagain.addEventListener("click", function () {
            updateApi(checklistDataWrap.dataset.saveId, checklistDataWrap.dataset.owner, checklistDataWrap.innerText);
        });
    }

    if (typeof makepublic != 'undefined' && makepublic != null) {
        makepublic.addEventListener("click", function (e) {
            e.preventDefault();
            postData(
                'https://app.vinegarsyndrome.com/make_public',
                'owner_id=' + checklistDataWrap.dataset.owner + '&listType=' + listType
            )
            .then(function (response) { return response.json(); })
            .then(function (data) {
                makepublic.innerText = data == 1 ? "Make private" : "Make public";
                sharelink.style.display = data == 1 ? "inline-block" : "none";
            })
            .catch(function (error) {
                console.log(error);
            });
        });
    }

    if (typeof checklistDataWrap.dataset.public != "undefined" && checklistDataWrap.dataset.public != null) {
        postData(
            'https://app.vinegarsyndrome.com/check',
            'owner_id=' + checklistDataWrap.dataset.owner + '&listType=' + listType
        )
        .then(function (response) { return response.json(); })
        .then(function (data) {
            if (data == false) {
                loadingWrap.innerText = "This list is private.";
            } else if (typeof data.value != "undefined") {
                jsonToRender = JSON.parse(data.value);
                if (data.name != '') {
                    listNames.forEach(function (el) {
                        el.innerText = data.name + "'s";
                    });
                }
                renderTable(jsonToRender, tableWrap, loadingWrap, true);
            }
        })
        .catch(function (error) {
            loadingWrap.innerText = "There's been an error. Try reloading the page.";
        });
    } else if (checklistDataWrap.innerText != '') {
        checklistDataJSON = JSON.parse(checklistDataWrap.innerText);
        postData(
            'https://app.vinegarsyndrome.com/init_checklist',
            'owner_id=' + checklistDataWrap.dataset.owner + '&listType=' + listType
        )
        .then(function (response) { return response.json(); })
        .then(function (data) {
            if (typeof data.id != "undefined") {
                checklistDataWrap.setAttribute('data-save-id', data.id);
                renderTable(checklistDataJSON, tableWrap, loadingWrap);
            } else {
                loadingWrap.innerText = "There's been an error. Try reloading the page.";
            }
        })
        .catch(function (error) {
            console.log(error);
            loadingWrap.innerText = "There's been an error. Try reloading the page.";
        });
    } else {
        postData(
            'https://app.vinegarsyndrome.com/setup_checklist',
            'owner_id=' + checklistDataWrap.dataset.owner + '&listType=' + listType
        )
        .then(function (response) { return response.json(); })
        .then(function (data) {
            if (typeof data != "undefined") {
                checklistDataWrap.setAttribute('data-save-id', data);
                checklistDataWrap.innerText = '{"checklist":{"have":[],"need":[],"hide":[]}}';
                checklistDataJSON = JSON.parse(checklistDataWrap.innerText);
                renderTable(checklistDataJSON, tableWrap, loadingWrap);
            } else {
                loadingWrap.innerText = "There's been an error. Try reloading the page.";
            }
        })
        .catch(function (error) {
            console.log(error);
            loadingWrap.innerText = "There's been an error. Try reloading the page.";
        });
    }

    if (typeof editionDropdowns !== 'undefined' && editionDropdowns != null) {
        editionDropdowns.forEach(function (sel) {
            sel.addEventListener("change", function (e) {
                setParentData(this, e.target.selectedIndex);
            });
        });
    }

    headerTitles.forEach(function (hTitle) {
        hTitle.addEventListener('click', function () {
            if (this.classList.contains('no-sort')) {
                return;
            }

            dataSelector = this.dataset.order.replace('row-', '');

            if (this.classList.contains('order-by-value')) {
                functionRef = organizeByValue;
            } else {
                functionRef = organizeByName;
            }

            if (currentSorting == null) {
                currentSorting = this;
            } else if (currentSorting != this) {
                currentSorting.classList.remove('sort-asc', 'sort-desc');
                currentSorting = this;
            }

            orderBy = "." + this.dataset.order;
            allRows = tableWrap.querySelectorAll(orderBy);
            nodeArray = Array.prototype.slice.call(allRows, 0);
            if (this.classList.contains('sort-asc')) {
                this.classList.remove('sort-asc');
                this.classList.add('sort-desc');
                nodeArray.sort(functionRef).reverse();
                sortClass = 'desc';
            } else if (this.classList.contains('sort-desc')) {
                this.classList.remove('sort-desc');
                this.classList.add('sort-asc');
                nodeArray.sort(functionRef);
                sortClass = 'asc';
            } else {
                sortClass = 'desc';
                this.classList.add('sort-desc');
                nodeArray.sort(functionRef).reverse();
            }

            newHeaderSort = colHeaders.indexOf(dataSelector) + "_" + sortClass;
            sortSelect.value = newHeaderSort;
            for (var i = 0; i < sortSelect.options.length; i++) {
                if (sortSelect.options[i].value == newHeaderSort) {
                    sortSelect.options[i].value.selected = true;
                    sortSelected.innerText = sortSelect.options[i].text;
                }
            }

            nodeArray.forEach(function (node, index) {
                node.parentElement.style.order = index + 1;
            });
        });
    });

    sortSelect.addEventListener("change", function (e) {
        sortSelected.innerText = this.children[e.target.selectedIndex].text;
        sortValue = e.target.value.split('_');
        orderBy = '.row-' + colHeaders[sortValue[0]];
        dataSelector = '[data-order="row-' + colHeaders[sortValue[0]] + '"]';
        sortClass = 'sort-' + sortValue[1];
        newHeaderSort = document.querySelector(dataSelector);

        currentSorting.classList.remove('sort-asc', 'sort-desc');
        currentSorting = newHeaderSort;

        if (sortValue[0] < 2) {
            functionRef = organizeByValue;
        } else {
            functionRef = organizeByName;
        }

        allRows = tableWrap.querySelectorAll(orderBy);
        nodeArray = Array.prototype.slice.call(allRows, 0);
        if (sortValue[1] == 'desc') {
            currentSorting.classList.add('sort-desc');
            nodeArray.sort(functionRef).reverse();
        } else if (sortValue[1] == 'asc') {
            currentSorting.classList.add('sort-asc');
            nodeArray.sort(functionRef);
        }

        nodeArray.forEach(function (node, index) {
            node.parentElement.style.order = index + 1;
        });
    });

    allHiddenCheck.forEach(function (check) {
        check.addEventListener('click', function () {
            this.parentElement.parentElement.classList.add('hide-row');
            hiddenCount++;
            hiddenCtnWp.innerText = hiddenCount;

            if (checklistDataJSON.checklist.hide.indexOf(this.value) == -1) {
                checklistDataJSON.checklist.hide.push(this.value);
            }

            updateData(checklistDataJSON, checklistDataWrap);
        });
    });

    if (typeof unhideBtn != "undefined" && unhideBtn != null) {
        unhideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            allHidden = tableWrap.querySelectorAll('.hide-row');

            if (allHidden.length > 0) {
                allHidden.forEach(function (hElm) {
                    hElm.classList.remove('hide-row');
                    hElm.children[2].firstElementChild.checked = false;
                });
            }
            hiddenCtnWp.innerText = 0;

            checklistDataJSON.checklist.hide = [];
            updateData(checklistDataJSON, checklistDataWrap);
        });
    }

    // Have function
    allHaveCheck.forEach(function (check) {
        check.addEventListener('click', function (e) {
            if (e.currentTarget.checked) {
                totalHaveVSChecklist++;
                if (e.currentTarget.parentElement.parentElement.classList.contains('need-item')) {
                    e.currentTarget.parentElement.parentElement.classList.remove('need-item');
                    e.currentTarget.parentElement.parentElement.children[1].firstElementChild.checked = false;

                    newArr = checklistDataJSON.checklist.need.filter(word => word != e.currentTarget.value);
                    checklistDataJSON.checklist.need = newArr;
                }

                e.currentTarget.parentElement.parentElement.children[1].firstElementChild.disabled = true;
                e.currentTarget.parentElement.parentElement.classList.add('have-item');
                if (checklistDataJSON.checklist.have.indexOf(e.currentTarget.value) == -1) {
                    checklistDataJSON.checklist.have.push(e.currentTarget.value);
                }

                if (e.currentTarget.parentElement.parentElement.classList.contains('group-variant')) {
                    selectVariant = e.currentTarget.parentElement.parentElement.children[8].firstElementChild;
                    for (var i = 0; i < selectVariant.options.length; i++) {
                        if (selectVariant.options[i].value == e.currentTarget.value) {
                            selectVariant.options[i].dataset.have = true;
                        }
                    }
                }
            } else {
                totalHaveVSChecklist--;
                e.currentTarget.parentElement.parentElement.classList.remove('have-item');
                e.currentTarget.parentElement.parentElement.children[1].firstElementChild.disabled = false;
                if (checklistDataJSON.checklist.have.indexOf(e.currentTarget.value) != -1) {
                    newArr = checklistDataJSON.checklist.have.filter(word => word != e.currentTarget.value);
                    checklistDataJSON.checklist.have = newArr;
                }

                if (e.currentTarget.parentElement.parentElement.classList.contains('group-variant')) {
                    selectVariant = e.currentTarget.parentElement.parentElement.children[8].firstElementChild;
                    for (var i = 0; i < selectVariant.options.length; i++) {
                        if (selectVariant.options[i].value == e.currentTarget.value) {
                            selectVariant.options[i].dataset.have = false;
                        }
                    }
                }
            }

            countVS.innerText = totalHaveVSChecklist;
            updateData(checklistDataJSON, checklistDataWrap);
            checklevels(checklistDataJSON, levelsDataJSON, levelVS);
        });
    });

    // Need function
    allNeedCheck.forEach(function (check) {
        check.addEventListener('click', function (e) {
            if (e.currentTarget.checked) {
                e.currentTarget.parentElement.parentElement.classList.add('need-item');
                if (checklistDataJSON.checklist.need.indexOf(e.currentTarget.value) == -1) {
                    checklistDataJSON.checklist.need.push(e.currentTarget.value);
                }

                if (e.currentTarget.parentElement.parentElement.classList.contains('group-variant')) {
                    selectVariant = e.currentTarget.parentElement.parentElement.children[8].firstElementChild;
                    for (var i = 0; i < selectVariant.options.length; i++) {
                        if (selectVariant.options[i].value == e.currentTarget.value) {
                            selectVariant.options[i].dataset.need = true;
                        }
                    }
                }
            } else {
                e.currentTarget.parentElement.parentElement.classList.remove('need-item');
                if (checklistDataJSON.checklist.need.indexOf(e.currentTarget.value) != -1) {
                    checklistDataJSON.checklist.need = checklistDataJSON.checklist.need.slice(checklistDataJSON.checklist.need.indexOf(e.currentTarget.value));
                }

                if (e.currentTarget.parentElement.parentElement.classList.contains('group-variant')) {
                    selectVariant = e.currentTarget.parentElement.parentElement.children[8].firstElementChild;
                    for (var i = 0; i < selectVariant.options.length; i++) {
                        if (selectVariant.options[i].value == e.currentTarget.value) {
                            selectVariant.options[i].dataset.need = false;
                        }
                    }
                }
            }

            updateData(checklistDataJSON, checklistDataWrap);
        });
    });

    searchInput.addEventListener('input', function (e) {
        clearTimeout(searchId);

        if (e.target.value != '') {
            searchId = setTimeout(searchByTitle, 100, e.target.value);
        } else {
            searchByTitle(e.target.value);
        }
    });

    clearinput.addEventListener("click", function () {
        searchInput.value = '';
        searchByTitle('');
    });

    sharelinkButton.addEventListener('click', function (e) {
        e.preventDefault();
        var tempText, tempTextBackup;
        if (copyInProcess == true) {
            return false;
        }
        tempTextBackup = this.innerText;
        tempText = tempTextBackup + '<span>(copied!)</span>';

        this.innerHTML = tempText;
        navigator.clipboard.writeText(this.href);

        copyInProcess = true;
        setTimeout(function () {
            copyInProcess = false;
            sharelinkButton.innerHTML = tempTextBackup;
        }, 1500);
    });
});

function searchByTitle(value) {
    var clearinput = document.querySelector('.clearinput');
    var tableWrap = document.querySelector('.vinegar-checklist-table-wrapper');
    var allRowsTitles = document.querySelectorAll('.checklist-table-row-content .row-title');
    var tosearch = value.toUpperCase();
    var toTest;

    if (value == '') {
        tableWrap.classList.remove('searching-input');
        clearinput.style.display = 'none';
    } else if (value != '' && !tableWrap.classList.contains('searching-input')) {
        tableWrap.classList.add('searching-input');
        clearinput.style.display = 'block';
    }

    allRowsTitles.forEach(function (el) {
        toTest = el.innerText.toUpperCase();
        if (!el.parentElement.classList.contains('hide-row')) {
            if (toTest.indexOf(tosearch) != -1) {
                el.parentElement.classList.add('found-item');
            } else if (el.parentElement.classList.contains('found-item')) {
                el.parentElement.classList.remove('found-item');
            }
        }
    });
}

function checklevels(JSONdata, levelsData, wrapper) {
    var levelName;
    var levels = levelsData.levels;
    var haveCount = totalHaveVSChecklist;
    var limit = levels.length - 1;

    for (let i = 0; i < levels.length; i++) {
        if (haveCount >= levels[i].number) {
            levelName = levels[i].name;
        } else {
            break;
        }
    }

    if (wrapper.innerText != levelName && typeof levelName != 'undefined') {
        wrapper.innerText = levelName;
    }
}

function updateData(JSONdata, wrapper) {
    wrapper.innerText = JSON.stringify(JSONdata);
    clearTimeout(timerId);

    timerId = setTimeout(function () {
        updateApi(wrapper.dataset.saveId, wrapper.dataset.owner, wrapper.innerText);
    }, 800);
}

function updateApi(key, ownerId, value) {
    var saving = document.querySelector("#saving");
    var savingspan = document.querySelector("#saving span");
    if (saving.classList.contains('error')) {
        saving.classList.remove('error');
    }
    savingspan.innerText = 'Saving';
    saving.style.display = 'block';

    fetch('https://app.vinegarsyndrome.com/update_checklist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'ownerId=' + ownerId + '&saveId=' + key + '&value=' + value + '&listType=' + listType
    })
    .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        savingspan.innerText = 'Saved';
        saving.classList.add('saved');
        setTimeout(fadeOut, 600, saving);
    })
    .catch(function (error) {
        savingspan.innerText = 'Theres been an error.';
        saving.classList.add('error');
    });
}

function renderTable(checklistDataJSON, table, loading, public = false) {
    var levelsDataWrap = document.querySelector('#checklistlevels');
    var levelsDataJSON = JSON.parse(levelsDataWrap.innerText);
    var hiddenCtnWp = document.querySelector('#hiddencount');
    var levelVS = document.querySelector('#cwc-vs-level');
    var countVS = document.querySelector('#cwc-vs-count');
    var skip;
    var allHiddenCheck = table.querySelectorAll('.hide-product-row');

    var allHaveCheck = table.querySelectorAll('.row-have input');
    var allNeedCheck = table.querySelectorAll('.row-need input');
    var selectVariants;

    if (checklistDataJSON.checklist.have.length > 0) {
        console.log(checklistDataJSON.checklist.have);
        checklistDataJSON.checklist.have.forEach(function (h) {
            allHaveCheck.forEach(function (input) {
                if (input.value == h) {
                    totalHaveVSChecklist++;
                    input.checked = true;
                    input.parentElement.parentElement.classList.add("have-item");
                    input.parentElement.parentElement.children[1].firstElementChild.disabled = true;
                    skip = input.value;
                    console.log(h);
                }

                if (input.parentElement.parentElement.classList.contains('group-variant')) {
                    selectVariants = input.parentElement.parentElement.children[8].firstElementChild;
                    for (var i = 0; i < selectVariants.options.length; i++) {
                        if (selectVariants.options[i].value == h) {
                            if (selectVariants.options[i].value != skip) {
                                totalHaveVSChecklist++;
                            }
                            selectVariants.options[i].dataset.have = true;

                            if (public) {
                                selectVariants.value = h;
                                selectVariants.dispatchEvent(new Event('change'));
                            } else if (!input.checked) {
                                input.checked = true;
                                input.parentElement.parentElement.classList.add("have-item");
                                input.parentElement.parentElement.children[1].firstElementChild.disabled = true;
                                selectVariants.value = h;
                                selectVariants.dispatchEvent(new Event('change'));
                            }
                        }
                    }
                }
            });
        });
        countVS.innerText = totalHaveVSChecklist;
        console.log(totalHaveVSChecklist);
        checklevels(checklistDataJSON, levelsDataJSON, levelVS);
    }

    // Render need
    if (checklistDataJSON.checklist.need.length > 0) {
        checklistDataJSON.checklist.need.forEach(function (n) {
            allNeedCheck.forEach(function (input) {
                if (input.value == n) {
                    input.checked = true;
                    input.parentElement.parentElement.classList.add("need-item");
                    skip = input.value;
                }

                if (input.parentElement.parentElement.classList.contains('group-variant')) {
                    selectVariants = input.parentElement.parentElement.children[8].firstElementChild;
                    for (var i = 0; i < selectVariants.options.length; i++) {
                        if (selectVariants.options[i].value == n) {
                            selectVariants.options[i].dataset.need = true;
                            if (public) {
                                selectVariants.value = n;
                                selectVariants.dispatchEvent(new Event('change'));
                            } else if (!input.parentElement.parentElement.children[0].firstElementChild.checked && !input.checked) {
                                input.checked = true;
                                input.parentElement.parentElement.classList.add("need-item");
                                selectVariants.value = n;
                                selectVariants.dispatchEvent(new Event('change'));
                            }
                        }
                    }
                }
            });
        });
    }

    // Render hide
    if (checklistDataJSON.checklist.hide.length > 0) {
        hiddenCtnWp.innerText = checklistDataJSON.checklist.hide.length;
        hiddenCount = checklistDataJSON.checklist.hide.length;
        checklistDataJSON.checklist.hide.forEach(function (hd) {
            allHiddenCheck.forEach(function (input) {
                if (input.value == hd) {
                    input.checked = true;
                    input.parentElement.parentElement.classList.add("hide-row");
                }
            });
        });
    }

    loading.style.display = "none";
    table.style.display = "block";
}

function organizeByValue(a, b) {
    var aVal = a.lastElementChild.checked ? 1 : 0;
    var bVal = b.lastElementChild.checked ? 1 : 0;
    return aVal - bVal;
}

function organizeByName(a, b) {
    var nameA, nameB;

    if (a.classList.contains('include-variants')) {
        nameA = a.firstElementChild.selectedOptions[0].innerText.toUpperCase();
    } else {
        nameA = a.innerText.toUpperCase();
    }

    if (b.classList.contains('include-variants')) {
        nameB = b.firstElementChild.selectedOptions[0].innerText.toUpperCase();
    } else {
        nameB = b.innerText.toUpperCase();
    }

    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }

    return 0;
}

// ** FADE OUT FUNCTION **
function fadeOut(el) {
    el.style.opacity = 1;
    (function fade() {
        if ((el.style.opacity -= .1) < 0) {
            el.style.display = "none";
            el.classList.remove('saved');
        } else {
            requestAnimationFrame(fade);
        }
    })();
}

// ** FADE IN FUNCTION **
function fadeIn(el, display) {
    el.style.opacity = 0;
    el.style.display = display || "block";
    (function fade() {
        var val = parseFloat(el.style.opacity);
        if (!((val += .1) > 1)) {
            el.style.opacity = val;
            requestAnimationFrame(fade);
        }
    })();
}

var h = document.getElementById("sticky-mobile");
var stuck = false;
var stickPoint = getDistance();

function getDistance() {
    var topDist = h.offsetTop;
    return topDist;
}

window.onscroll = function (e) {
    var distance = getDistance() - window.pageYOffset;
    var offset = window.pageYOffset;
    if ((distance <= 0) && !stuck) {
        h.parentElement.parentElement.classList.add('stuck');
        stuck = true;
    } else if (stuck && (offset <= stickPoint)) {
        h.parentElement.parentElement.classList.remove('stuck');
        stuck = false;
    }
}

function setParentData(element, selectedIndex) {
    var parentElement = element.parentElement.parentElement;
    var selectedOption = element.options[selectedIndex];
    var haveInput = parentElement.querySelector('.row-have input');
    var needInput = parentElement.querySelector('.row-need input');
    var availableWrapper = parentElement.querySelector('.row-status');
    var skuAnchor = parentElement.querySelector('.row-cat a');
    var titleAnchor = parentElement.querySelector('.row-title a');

    if (selectedOption.dataset.available == "true") {
        availableWrapper.innerText = "IN STOCK";
    } else {
        availableWrapper.innerText = "SOLD OUT";
    }

    skuAnchor.href = selectedOption.dataset.url;
    titleAnchor.href = selectedOption.dataset.url;
    skuAnchor.innerText = selectedOption.value;
    haveInput.value = selectedOption.value;
    needInput.value = selectedOption.value;
    parentElement.dataset.id = selectedOption.value;

    if (selectedOption.dataset.have == "true") {
        haveInput.checked = true;
        parentElement.classList.add('have-item');
        needInput.disabled = true;
    } else {
        haveInput.checked = false;
        parentElement.classList.remove('have-item');
        needInput.disabled = false;
    }

    if (selectedOption.dataset.need == "true") {
        needInput.checked = true;
        parentElement.classList.add('need-item');
    } else {
        needInput.checked = false;
        parentElement.classList.remove('need-item');
    }
}